/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import { addSubscription } from './Payment.services';
import type { PaymentValues } from "./Payment.types";

export default function usePayment() {
  const queryClient = useQueryClient();
  const packages = queryClient.getQueryData<any>(["packages"]);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const sendInvoice = useMutation({
    mutationFn: (data: PaymentValues) => addSubscription(data),
  });

  const form = useFormContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const chosenPackage = packages?.resultList?.find((pkg: any) => pkg.id === form.watch("packageId"));
  const billingPeriod = form.watch("billingPeriod");

  const handleChangePackage = () => {
    searchParams.set("tab", "package");
    setSearchParams(searchParams);
    form.setValue("packageId", null);
  };

  const handleSendInvoice = () => {
    setIsOpen(true);
    sendInvoice.mutate({
      packageId: chosenPackage.package.id,
      billingCycleId: Number(billingPeriod),
      paymentTypeId: 1,
    });
  };

  return {
    packages,
    sendInvoice,
    sendInvoicePending: sendInvoice.isPending,
    isOpen,
    setIsOpen,
    handleChangePackage,
    handleSendInvoice,
    chosenPackage,
    billingPeriod,
  };
}
